<h3 class="settings-heading">{{ 'settings.model' | translate }}</h3>
<mat-form-field class="w-100" appearance="outline">
  <!-- Open Angular issue on "Incorrect use of <label for=FORM_ELEMENT>" https://github.com/angular/components/issues/27241 -->
  <mat-select [ngModel]="selectedModel" (ngModelChange)="onSelectModel($event)">
    <mat-option [value]="ModelType.GPT_4_1_MINI">OpenAI GPT-4.1 Mini</mat-option>
    <mat-option [value]="ModelType.GPT_4_1">OpenAI GPT-4.1</mat-option>
  </mat-select>
</mat-form-field>

<h3 class="settings-heading">{{ 'settings.searchMode' | translate }}</h3>
<mat-radio-group
  aria-labelledby="radio-group-label"
  class="radio-group"
  [ngModel]="searchMode"
  (ngModelChange)="updateSearchMode($event)">
  <mat-radio-button
    class="radio-button"
    color="primary"
    *ngFor="let mode of searchModes"
    [value]="mode">
    {{ 'settings.' + mode + 'Search' | translate }}
    <mat-icon
      matTooltip="{{ 'settings.' + mode + 'SearchTooltip' | translate }}"
      class="tooltip-icon"
      inline>
      info
    </mat-icon>
  </mat-radio-button>
</mat-radio-group>

<h3 class="settings-heading">{{ 'settings.chatMode' | translate }}</h3>
<mat-radio-group
  aria-labelledby="radio-group-label"
  class="radio-group"
  [ngModel]="chatMode"
  (ngModelChange)="updateChatMode($event)">
  <mat-radio-button
    class="radio-button"
    color="primary"
    *ngFor="let mode of chatModes"
    [value]="mode">
    {{ 'settings.' + mode + 'Chat' | translate }}
    <mat-icon
      matTooltip="{{ 'settings.' + mode + 'ChatTooltip' | translate }}"
      class="tooltip-icon"
      inline>
      info
    </mat-icon>
  </mat-radio-button>
</mat-radio-group>

<h3 class="settings-heading pt-4">Top_K:</h3>
<app-slider></app-slider>
